import $ from 'qwery';

const titleAttr = '[data-item-selector-title]';
const optionsAttr = '[data-item-selector-options]';
const optionAttr = '[data-item-selector-option]';
const selectedOptionInputAttr = '[data-item-selector-selected]';

const hiddenClass = 'is-hidden';
const optionsAboveClass = 'itemSelector-list--above';
const optionsBelowClass = 'itemSelector-list--below';

function placeOptionsAboveTitle () {
    const boundingClientRect = $(titleAttr, this)[0].getBoundingClientRect();
    const clientHeightCentre = document.documentElement.clientHeight / 2;
    if (boundingClientRect.bottom > clientHeightCentre) {
        return true;
    }
    return false;
}

function placeOptions () {
    $(optionsAttr, this)[0].classList.remove(optionsAboveClass, optionsBelowClass);
    if (placeOptionsAboveTitle.call(this)) {
        $(optionsAttr, this)[0].classList.add(optionsAboveClass);
    } else {
        $(optionsAttr, this)[0].classList.add(optionsBelowClass);
    }
}

function hideOptions (event) {
    if (event && event.ignore) return;
    $('body')[0].removeEventListener('click', hideOptions, false);
    $(optionsAttr).forEach(itemSelectorOption => {
        itemSelectorOption.classList.add(hiddenClass);
    });
}

function showOptions (event) {
    event.ignore = true;
    const show = $(optionsAttr, this)[0].classList.contains(hiddenClass);
    hideOptions();
    if (show) {
        $(optionsAttr, this)[0].classList.remove(hiddenClass);
        placeOptions.call(this);
    }
    $('body')[0].addEventListener('click', hideOptions, false);
}

function updateSelectedOptionInput (event) {
    const inputs = $(selectedOptionInputAttr, this);
    if (inputs.length === 1) {
        inputs[0].value = event.currentTarget.getAttribute('data-item-selector-option');
    }
}

function init () {
    $('[data-item-selector]').forEach(itemSelector => {
        $(titleAttr, itemSelector)[0].addEventListener('click', showOptions.bind(itemSelector), false);
        $(optionAttr, itemSelector).forEach(itemSelectorOption => {
            itemSelectorOption.addEventListener('click', updateSelectedOptionInput.bind(itemSelector), false);
        });

        const config = itemSelector.getAttribute('data-item-selector');
        if (config) {
            const jsonData = JSON.parse(config);
            if (jsonData && jsonData.triggers) {
                for (const key in jsonData.triggers) {
                    const el = $(jsonData.triggers[key]);
                    if (el.length > 0) {
                        el[0].addEventListener('click', showOptions.bind(itemSelector), false);
                    }
                }
            }
        }
    });
}

export default {
    init
};
